import * as React from 'react';
import { Trans } from 'react-i18next';

import { Text } from '../../text';
import { Icon } from '../../icon';

export function ActionsBar({ undoAction, clearAction, onDoneAction }) {
  return (
    <div className="action-bar">
      <div className="action-bar__action" onClick={() => onDoneAction()}>
        <Text color="#90A4AE" style={{ marginRight: 6 }}>
          <Trans>Done</Trans>
        </Text>
        <Icon color="#90A4AE" size={18} name="check" />
      </div>
      <div className="action-bar__action" onClick={() => undoAction()}>
        <Text color="#90A4AE" style={{ marginRight: 6 }}>
          <Trans>Undo</Trans>
        </Text>
        <Icon color="#90A4AE" size={28} name="pba-arrow-left" />
      </div>
      <div className="action-bar__action" onClick={() => clearAction()}>
        <Text color="#90A4AE" style={{ marginRight: 10 }}>
          <Trans>Clear</Trans>
        </Text>
        <Icon color="#90A4AE" size={18} name="erase" />
      </div>
    </div>
  );
}
